export const common = {
  nav: {
    platform: 'Platform',
    solutions: 'Oplossingen',
    resources: 'Bronnen',
    company: 'Bedrijf',
    requestDemo: 'Vraag Demo Aan',
    // Platform dropdown
    dashboard: 'Dashboard',
    analytics: 'Analyses',
    monitoring: 'Monitoring',
    compliance: 'Compliance',
    // Solutions dropdown
    iotDevices: 'IoT-Apparaten',
    dataManagement: 'Gegevensbeheer',
    aiAlerts: 'AI-Waarschuwingen',
    cbamCompliance: 'CBAM-Compliance',
    // Resources dropdown
    documentation: 'Documentatie',
    apiReference: 'API-Referentie',
    caseStudies: 'Casestudies',
    blog: 'Blog',
    // Company dropdown
    about: 'Over Ons',
    careers: 'Carrières',
    contact: 'Contact',
    privacy: 'Privacy',
  },
  hero: {
    badge: 'Industrieel IoT Platform',
    title1: 'Digitale Transformatie',
    title2: 'Real-Time Monitoring',
    title3: 'Carbon Compliance',
    subtitle: 'Versterk uw industriële operaties met AI-gedreven inzichten, realtime gegevensverwerking en EU-koolstofvoetafdruk compliance-oplossingen',
    startTrial: 'Start Gratis Proefperiode',
    watchDemo: 'Bekijk Demo',
    scrollExplore: 'Scroll om te verkennen',
    // Statistics
    stat1Value: '500+',
    stat1Label: 'Zakelijke Klanten',
    stat2Value: '50.000+',
    stat2Label: 'Verbonden Apparaten',
    stat3Value: '10M+',
    stat3Label: 'Datapunten / Dag',
    stat4Value: '99,9%',
    stat4Label: 'Uptime Garantie'
  },
  features: {
    sectionTitle: 'Kernoplossingen',
    sectionSubtitle: 'Uitgebreid platform voor industriële digitale transformatie',
    feature1Title: 'Apparaatbewaking',
    feature1Desc: 'Real-time monitoring van industriële apparatuur met geavanceerde sensornetwerken en IoT-connectiviteit',
    feature2Title: 'Gegevenslevenscyclusbeheer',
    feature2Desc: 'Compleet gegevenslevenscyclusbeheer van verzameling tot analyse en archivering',
    feature3Title: 'AI-Aangedreven Waarschuwingen',
    feature3Desc: 'Dubbele waarschuwingsmodus: definieer uw eigen drempelwaarde- en conditieregels, of laat AI automatisch anomalieën en abnormale patronen detecteren — ontvang meldingen voordat problemen escaleren.',
    feature4Title: 'CBAM Compliance',
    feature4Desc: 'EU Carbon Border Adjustment Mechanism compliance-oplossingen met geautomatiseerde rapportage',
    learnMore: 'Meer Informatie'
  },
  dashboard: {
    badge: 'Live Dashboard Voorbeeld',
    title: 'Monitor Alles in Real-Time',
    subtitle: 'Aanpasbare dashboards met drag-and-drop widgets, realtime waarschuwingen en uitgebreide datavisualisatie',
    metric1: '99,9%',
    metric1Label: 'Uptime',
    metric2: '<50ms',
    metric2Label: 'Reactietijd',
    metric3: '10K+',
    metric3Label: 'Datapunten/sec',
    exploreDashboard: 'Verken Dashboard'
  },
  compliance: {
    sectionTitle: 'CBAM Compliance Eenvoudig Gemaakt',
    sectionSubtitle: 'Geautomatiseerde koolstofvoetafdruk tracking en EU compliance-documentatie',
    card1Title: 'Geautomatiseerde Rapportage',
    card1Desc: 'Genereer automatisch compliance-rapporten met realtime CO2-emissiegegevens',
    card2Title: 'Koolstofvoetafdruk Tracking',
    card2Desc: 'Volg en analyseer CO2-uitstoot in uw gehele productieketen',
    card3Title: 'Compliance Documentatie',
    card3Desc: 'Vooraf gebouwde sjablonen voor EU CBAM compliance-documentatie en certificering',
    downloadGuide: 'Download Compliance Gids',
    viewDetails: 'Meer Informatie'
  },
  testimonials: {
    sectionTitle: 'Vertrouwd door Industrieleiders',
    review1Title: 'Baanbrekend platform',
    review1Text: 'BridgeAI heeft onze productieactiviteiten getransformeerd. Real-time monitoring en AI-waarschuwingen verminderden downtime met 40%.',
    review1Name: 'Michael Chen',
    review1Position: 'Operations Director, TechManufacturing Co.',
    review2Title: 'CBAM compliance vereenvoudigd',
    review2Text: 'De geautomatiseerde compliance-rapportage bespaarde ons talloze uren. EU CBAM-documentatie is nu moeiteloos.',
    review2Name: 'Sarah van der Berg',
    review2Position: 'Sustainability Manager, GreenIndustries NL',
    review3Title: 'Uitzonderlijke data-inzichten',
    review3Text: 'De analysemogelijkheden zijn uitstekend. We kunnen nu weken van tevoren apparatuurstoringen voorspellen.',
    review3Name: 'Klaus Müller',
    review3Position: 'CTO, Industrie Solutions GmbH',
    review4Title: 'Naadloze ERP-integratie',
    review4Text: 'Integratie met ons bestaande ERP-systeem verliep soepel. De meertalige ondersteuning is perfect voor ons wereldwijde team.',
    review4Name: 'Emma Johnson',
    review4Position: 'IT Director, GlobalTech Industries',
    review5Title: 'Uitstekende ondersteuning',
    review5Text: 'De aanpasbare dashboards en op rollen gebaseerde machtigingen passen perfect bij onze organisatiestructuur.',
    review5Name: 'Pierre Dubois',
    review5Position: 'Plant Manager, EuroManufacturing SA',
    review6Title: 'ROI in 3 maanden',
    review6Text: 'We zagen meetbare ROI binnen drie maanden. Alleen al het voorspellend onderhoud betaalde voor het platform.',
    review6Name: 'Anna Kowalski',
    review6Position: 'CFO, Industrial Dynamics Ltd.'
  },
  cta: {
    title: 'Klaar om Uw Operaties te Transformeren?',
    subtitle: 'Start uw 30-daagse gratis proefperiode, geen creditcard vereist',
    getStarted: 'Nu Aan de Slag'
  },
  footer: {
    tagline: 'Industriële digitale transformatie mogelijk maken',
    platformTitle: 'Platform',
    dashboard: 'Dashboard',
    analytics: 'Analytics',
    monitoring: 'Monitoring',
    compliance: 'Compliance',
    solutionsTitle: 'Oplossingen',
    iotDevices: 'IoT Apparaten',
    dataManagement: 'Gegevensbeheer',
    aiAlerts: 'AI Waarschuwingen',
    cbamCompliance: 'CBAM Compliance',
    resourcesTitle: 'Bronnen',
    documentation: 'Documentatie',
    apiReference: 'API Referentie',
    caseStudies: 'Case Studies',
    blog: 'Blog',
    companyTitle: 'Bedrijf',
    about: 'Over Ons',
    careers: 'Carrières',
    contact: 'Contact',
    privacy: 'Privacybeleid',
    stayConnected: 'Blijf Verbonden',
    newsletterText: 'Ontvang platformupdates en branche-inzichten',
    emailPlaceholder: 'Voer uw e-mail in',
    subscribe: 'Abonneren',
    subscribing: 'Abonneren...',
    subscribeSuccess: 'Bedankt voor uw abonnement!',
    errorInvalidEmail: 'Voer een geldig e-mailadres in',
    errorSubmission: 'Abonnement mislukt. Probeer het opnieuw.',
    copyright: '© 2026 BridgeAI. Alle rechten voorbehouden.'
  },
  dataLifecycle: {
    modalTitle: 'Gegevenslevenscyclusbeheer',
    modalSubtitle: 'End-to-end industriële gegevensstroom — van apparaat tot dashboard',
    flowLabel: 'Volledige Gegevensstroom',
    flowTitle: 'Van Industrieel Apparaat naar Inzicht',
    flowDesc: 'BridgeAI beheert de volledige gegevensreis: het vastleggen van ruwe telemetrie van veldapparaten, verwerking aan de edge, veilige overdracht naar de cloud en het leveren van bruikbare inzichten via dashboards en API\'s.',
    step1Title: 'Industriële Apparaten',
    step1Desc: 'Verbind PLC\'s, aandrijvingen, meters en controllers via Modbus, RS485, OPC-UA, Snap7, PROFINET en meer.',
    step2Title: 'Sensor Telemetrie Vastlegging',
    step2Desc: 'Verzamel temperatuur-, druk-, trillings-, stroom-, vermogen- en aangepaste sensorgegevens met hoge frequentie.',
    step3Title: 'Slimme Edge Verwerking',
    step3Desc: 'Lokaal edge-apparaat filtert, aggregeert en comprimeert gegevens vóór overdracht — vermindert bandbreedte met tot 80%.',
    step4Title: 'Veilige Overdracht',
    step4Desc: 'Stuur gegevens via MQTT, aangepaste TCP/UDP, HTTP/REST of WebSocket met end-to-end TLS-versleuteling.',
    step5Title: 'ETL Pipeline',
    step5Desc: 'Extraheer, transformeer en laad gegevens met validatie en verrijking voor kwaliteit en consistentie.',
    step6Title: 'Gegevensbus',
    step6Desc: 'Distribueer gegevensstromen via Kafka of RabbitMQ event-bus om producenten en consumenten te ontkoppelen.',
    step7Title: 'Opslaglaag',
    step7Desc: 'Sla gegevens op in PostgreSQL voor relationele records, TimescaleDB/InfluxDB voor tijdreeksen en S3 voor archieven.',
    step8Title: 'Gegevenspipelines',
    step8Desc: 'Routeer gegevens door normale verwerking, AI-inferentie, alarmevaluatie en rapportgeneratie pipelines.',
    step9Title: 'Web- & App-Presentatie',
    step9Desc: 'Lever inzichten via realtime web-dashboards, mobiele apps, REST-API\'s, webhooks en ERP-integraties.',
    pipelinesTitle: 'Verwerkings Pipeline Types',
    pipeline1Title: 'Normale Verwerkings Pipeline',
    pipeline1Desc: 'Standaard gegevensstroom voor aggregatie, KPI-berekening, drempelwaarschuwingen en geplande rapportgeneratie. Verwerkt het grootste deel van de operationele gegevens met lage latentie en hoge betrouwbaarheid.',
    pipeline2Title: 'AI Verwerkings Pipeline',
    pipeline2Desc: 'Machine learning inferentie pipeline voor anomaliedetectie, voorspellend onderhoud en patroonherkenning. Modellen worden getraind op historische gegevens en continu bijgewerkt.',
    stat1: 'End-to-End Latentie',
    stat2: 'Datapunten / sec',
    stat3: 'Platform Uptime',
    stat4: 'Industriële Protocollen',
  },
  aiAlerts: {
    modalTitle: 'AI-Aangedreven Waarschuwingen',
    modalSubtitle: 'Dubbele waarschuwingsmodus: gebruikersregels + AI anomaliedetectie',
    badge: 'Intelligente Waarschuwingsmotor',
    flowTitle: 'Elk Probleem Voor Zijn',
    flowDesc: 'BridgeAI combineert regelgebaseerde waarschuwingen met AI-gestuurde anomaliedetectie — u wordt direct gewaarschuwd wanneer er iets misgaat, of zelfs voordat het gebeurt.',
    flowLabel: 'Waarschuwingsverwerkingsstroom',
    flow1: 'Sensorgegevens',
    flow2: 'Regel-Engine',
    flow3: 'AI-Analyse',
    flow4: 'Waarschuwing Geactiveerd',
    flow5: 'Melding',
    flow6: 'Actie / Oplossing',
    dualModeLabel: 'Dubbele Waarschuwingsmodus',
    rule1Title: 'Gebruikergedefinieerde Regelwaarschuwingen',
    rule1Desc: 'Maak aangepaste waarschuwingsregels op basis van drempelwaarden, condities, tijdvensters en multi-metrische logica. Volledige controle over wanneer en hoe u wordt gewaarschuwd.',
    rule2Title: 'AI Automatische Anomaliedetectie',
    rule2Desc: 'AI leert continu het normale gedrag van uw apparatuur en activeert automatisch waarschuwingen bij anomalieën, abnormale patronen of vroege tekenen van storingen.',
    featuresLabel: 'Waarschuwingsmogelijkheden',
    feat1Title: 'Multi-Kanaal Meldingen',
    feat1Desc: 'Lever waarschuwingen via e-mail, SMS, webhook, PagerDuty of Slack — bereik direct de juiste persoon.',
    feat2Title: 'Voorspellende Inzichten',
    feat2Desc: 'AI-trendanalyse en prognoses helpen u oorzaken te begrijpen en toekomstige problemen te voorspellen.',
    feat3Title: 'Waarschuwingsgeschiedenis & Audit',
    feat3Desc: 'Volledig waarschuwingslogboek met audittrail, herhaling en export — volledig inzicht in elk evenement.',
    feat4Title: 'Slim Waarschuwingsbeheer',
    feat4Desc: 'Prioriteitsniveaus, escalatiebeleid, onderdrukking en groepering om ruis te verminderen.',
    stat1: 'Waarschuwingslatentie',
    stat2: 'Detectienauwkeurigheid',
    stat3: 'Regeltypen',
    stat4: 'Meldingskanalen',
  },
  cbam: {
    badge: 'EU CBAM Digitale Vereisten',
    modalTitle: 'CBAM Digitaal Systeem Kernvereisten',
    modalSubtitle: 'Van datahiërarchie tot volledige MRV-digitalisering — EU koolstofgrens compliance',
    tab1: 'Datahiërarchie: Org → Product-/Lijnniveau',
    tab2: 'MRV Volledig Proces Digitalisering',

    dataLayerIntroTitle: 'CBAM vereist emissies op productniveau, niet bedrijfstotalen',
    dataLayerIntroDesc: 'CBAM verplicht rapportage van ingebedde emissies per ton product, inclusief directe + indirecte emissies, toewijzing op productielijn/procesniveau, en werkelijke meetwaarden als prioriteit boven schattingen.',

    dataHierarchyTitle: 'Drie-Niveau Datahiërarchie',
    level1Label: 'Niveau 1 — Organisatie',
    level1Title: 'Bedrijfs- / Groepsniveau',
    level1Desc: 'Geaggregeerd totaal energieverbruik en CO2-emissies op bedrijfsniveau. Geschikt voor jaarlijkse duurzaamheidsrapporten en ESG-openbaarmakingen, maar onvoldoende voor CBAM-productvereisten.',
    level1Limit: 'Beperking: Emissies kunnen niet worden toegewezen aan specifieke producten of batches — voldoet niet aan CBAM-vereisten.',
    level2Label: 'Niveau 2 — Faciliteit',
    level2Title: 'Fabriek- / Productielijn Niveau',
    level2Desc: 'Energie en emissies bijhouden per productielijn of proceseenheid. Maakt toewijzing van koolstofkosten aan productcategorieën mogelijk en ondersteunt KPI-beheer op procesniveau.',
    level2Limit: 'Gedeeltelijke naleving: Ondersteunt toewijzing op lijnniveau maar mist mogelijk realtime granulariteit voor batch-tracering.',
    level3Label: 'Niveau 3 — Apparaat',
    level3Title: 'Apparaat- / Batchniveau (CBAM Kern)',
    level3Desc: 'Realtime gegevensacquisitie van DCS/SCADA/PLC op apparaatniveau. Maakt nauwkeurige energie- en emissietoewijzing per productbatch mogelijk, voldoet aan de werkelijke meetprioriteitseis van CBAM.',
    level3Limit: 'Volledige naleving: Realtimemeting + batch-tracering + toewijzing op productniveau — de gouden standaard voor CBAM.',
    cbamRequired: 'CBAM Vereist',

    deviceCapTitle: 'BridgeAI Apparaatniveau Acquisitiecapaciteit',
    deviceCapDesc: 'BridgeAI verbindt rechtstreeks met DCS-, SCADA- en PLC-systemen via Modbus, OPC-UA, Snap7 en 15+ industriële protocollen. Energie- en emissiegegevens worden per apparaat, per batch vastgelegd en automatisch aan producten toegewezen.',

    mrvIntroTitle: 'EU MRV-verordening: Drie kernvereisten voor koolstofgegevens',
    mrvIntroDesc: 'Het EU-kader voor Monitoring, Rapportage en Verificatie (MRV) vereist dat alle voor CBAM ingediende CO2-emissiegegevens traceerbaar, verifieerbaar en manipulatiebestendig zijn.',

    mrvPillarsTitle: 'MRV Drie Pijlers',
    mrv1Title: 'Traceerbaar — Gegevensbron Controleerbaar',
    mrv1Desc: 'Elk datapunt moet terug te voeren zijn naar het broninstrument. Kalibratierecords, sensor-metadata en meettijdstempels moeten worden opgeslagen en opvraagbaar zijn.',
    mrv1Tag1: 'Instrumentkalibratie Records',
    mrv1Tag2: 'Sensor Metadata',
    mrv1Tag3: 'Meettijdstempels',
    mrv2Title: 'Verifieerbaar — Klaar voor Derde-Partij Audit',
    mrv2Desc: 'Gegevens moeten ter plaatse verificatie door geaccrediteerde derde partijen ondersteunen. BridgeAI biedt gestructureerde audit-exports, gegevensherhaling en rolgebaseerde toegang voor verificateurs.',
    mrv2Tag1: 'Gestructureerde Audit Export',
    mrv2Tag2: 'Gegevensherhaling',
    mrv2Tag3: 'Verificateur Toegangscontrole',
    mrv3Title: 'Manipulatiebestendig — Blockchain Notarisatie',
    mrv3Desc: 'Emissierecords moeten onveranderlijk zijn. BridgeAI ondersteunt blockchain-gebaseerde notarisatie van kritieke gegevens-snapshots — cryptografisch bewijs dat records niet zijn gewijzigd.',
    mrv3Tag1: 'Blockchain Notarisatie',
    mrv3Tag2: 'Cryptografische Hash',
    mrv3Tag3: 'Onveranderlijk Auditspoor',

    mrvFlowTitle: 'MRV Digitale Bewijsketen',
    mrvFlow1: 'Apparaat-\nMeting',
    mrvFlow2: 'Veilige\nOpslag',
    mrvFlow3: 'Blockchain-\nNotarisatie',
    mrvFlow4: 'Compliance-\nRapport',
    mrvFlow5: 'Derde-Partij\nVerificatie',

    stat1Val: '100%',
    stat1Label: 'Data Traceerbaarheid',
    stat2Val: 'ISO 14064',
    stat2Label: 'Verificatie Gereed',
    stat3Val: 'Blockchain',
    stat3Label: 'Manipulatiebestendig',
  },
  cbamModal: {
    // ... existing code ...
  },
  contactForm: {
    title: 'Vraag een demo aan',
    fields: {
      name: 'Volledige naam',
      company: 'Bedrijfsnaam',
      email: 'E-mailadres',
      phone: 'Telefoonnummer',
      message: 'Bericht'
    },
    placeholders: {
      name: 'Voer uw volledige naam in',
      company: 'Voer uw bedrijfsnaam in',
      email: 'Voer uw e-mailadres in',
      phone: 'Voer uw telefoonnummer in',
      message: 'Vertel ons over uw vereisten...'
    },
    errors: {
      nameRequired: 'Naam is verplicht',
      companyRequired: 'Bedrijfsnaam is verplicht',
      emailRequired: 'E-mail is verplicht',
      emailInvalid: 'Voer een geldig e-mailadres in',
      phoneRequired: 'Telefoonnummer is verplicht',
      messageRequired: 'Bericht is verplicht',
      messageTooLong: 'Bericht mag niet meer dan 500 tekens bevatten'
    },
    submit: 'Verzoek indienen',
    submitting: 'Verzenden...',
    successTitle: 'Bedankt!',
    successMessage: 'We hebben uw verzoek ontvangen en nemen binnenkort contact met u op.'
  },
  about: {
    title: 'Over Ons',
    introTitle: 'Wie Wij Zijn',
    introText: 'BridgeAI is een toonaangevende leverancier van industriële IoT- en digitale transformatieoplossingen. We helpen fabrikanten operaties te optimaliseren, de koolstofvoetafdruk te verminderen en EU-compliance te bereiken door middel van geavanceerde technologie en AI-gedreven inzichten.',
    missionTitle: 'Onze Missie',
    missionText: 'Industriële ondernemingen versterken met intelligente, datagestuurde oplossingen die operationele uitmuntendheid en duurzame groei stimuleren.',
    visionTitle: 'Onze Visie',
    visionText: 'De wereldwijde standaard worden voor industriële digitale transformatie, waardoor een slimmere, groenere en efficiëntere productietoekomst mogelijk wordt.',
    valuesTitle: 'Kernwaarden',
    value1Title: 'Innovatie',
    value1Text: 'Voortdurend de grenzen van industriële IoT- en AI-technologie verleggen.',
    value2Title: 'Betrouwbaarheid',
    value2Text: 'Robuuste, veilige en bedrijfskritische oplossingen leveren waar onze klanten op kunnen vertrouwen.',
    value3Title: 'Duurzaamheid',
    value3Text: 'Toegewijd aan het helpen van industrieën om de impact op het milieu te verminderen en klimaatneutraliteit te bereiken.',
    value4Title: 'Partnerschap',
    value4Text: 'Langetermijnrelaties opbouwen op basis van wederzijds succes en gedeelde waarden.',
    teamTitle: 'Ons Team',
    teamText: 'Ons team bestaat uit brancheveteranen, datawetenschappers en IoT-specialisten met tientallen jaren gecombineerde ervaring in productie, automatisering en bedrijfssoftware. We brengen diepgaande domeinexpertise en een passie voor het oplossen van complexe industriële uitdagingen.',
    teamExperts: 'Branche-experts',
    teamYears: 'Jaar Ervaring',
    teamProjects: 'Afgeleverde Projecten'
  },
  contact: {
    title: 'Contact',
    infoTitle: 'Neem Contact Op',
    infoText: 'Heeft u vragen of wilt u meer weten over BridgeAI? Ons team staat klaar om te helpen. Neem contact met ons op via een van de onderstaande kanalen.',
    addressTitle: 'Kantooradres',
    addressText: 'Hengelosestraat 581, 7581 AG Enschede, Nederland',
    emailTitle: 'E-mail',
    phoneTitle: 'Telefoon',
    hoursTitle: 'Openingstijden',
    hoursText: 'Maandag - Vrijdag: 9:00 - 18:00 uur CET',
    formTitle: 'Stuur Ons Een Bericht',
    name: 'Volledige Naam',
    company: 'Bedrijfsnaam',
    email: 'E-mailadres',
    phone: 'Telefoonnummer',
    message: 'Bericht',
    namePlaceholder: 'Voer uw volledige naam in',
    companyPlaceholder: 'Voer uw bedrijfsnaam in',
    emailPlaceholder: 'Voer uw e-mailadres in',
    phonePlaceholder: 'Voer uw telefoonnummer in',
    messagePlaceholder: 'Vertel ons hoe we kunnen helpen...',
    errorName: 'Naam is verplicht',
    errorCompany: 'Bedrijfsnaam is verplicht',
    errorEmail: 'E-mail is verplicht',
    errorEmailInvalid: 'Voer een geldig e-mailadres in',
    errorPhone: 'Telefoonnummer is verplicht',
    errorMessage: 'Bericht is verplicht',
    errorMessageLength: 'Bericht mag niet meer dan 500 tekens bevatten',
    submit: 'Bericht Verzenden',
    submitting: 'Verzenden...',
    successMessage: 'Bedankt! Uw bericht is succesvol verzonden.'
  },
  privacy: {
    title: 'Privacybeleid',
    lastUpdated: 'Laatst bijgewerkt:',
    lastUpdatedDate: '15 januari 2026',
    introTitle: 'Introductie',
    introText: 'BridgeAI ("wij", "ons" of "onze") zet zich in voor de bescherming van uw privacy. Dit Privacybeleid legt uit hoe we uw informatie verzamelen, gebruiken, openbaar maken en beschermen wanneer u ons industriële IoT-platform en -diensten gebruikt.',
    collectionTitle: 'Informatie Die We Verzamelen',
    collectionText: 'We verzamelen informatie die u rechtstreeks aan ons verstrekt, waaronder:',
    collectionItem1: 'Persoonlijke identificatie-informatie (naam, e-mailadres, telefoonnummer, bedrijfsnaam)',
    collectionItem2: 'Accountgegevens en authenticatiegegevens',
    collectionItem3: 'Industriële apparaatgegevens, sensormetingen en telemetrie-informatie',
    collectionItem4: 'Gebruiksgegevens, logbestanden en analyse-informatie',
    usageTitle: 'Hoe We Uw Informatie Gebruiken',
    usageText: 'We gebruiken de verzamelde informatie om:',
    usageItem1: 'Ons platform en diensten te leveren, onderhouden en verbeteren',
    usageItem2: 'Transacties te verwerken en gerelateerde informatie te verzenden',
    usageItem3: 'Technische meldingen, updates, beveiligingswaarschuwingen en ondersteuningsberichten te verzenden',
    usageItem4: 'Te reageren op uw opmerkingen, vragen en klantenserviceverzoeken',
    storageTitle: 'Gegevensopslag en Beveiliging',
    storageText: 'We implementeren industriestandaard beveiligingsmaatregelen om uw gegevens te beschermen, waaronder versleuteling, toegangscontroles en regelmatige beveiligingsaudits. Uw industriële gegevens worden opgeslagen in veilige, EU-conforme datacenters met redundantie- en back-upsystemen.',
    sharingTitle: 'Informatie Delen',
    sharingText: 'We verkopen, verhandelen of verhuren uw persoonlijke informatie niet aan derden. We kunnen uw informatie alleen delen onder de volgende omstandigheden:',
    sharingNote: 'Belangrijk:',
    sharingNoteText: 'We zullen uw industriële apparaatgegevens of eigendomsinformatie nooit delen zonder uw uitdrukkelijke toestemming.',
    rightsTitle: 'Uw Rechten',
    rightsText: 'Onder de AVG en toepasselijke gegevensbeschermingswetten heeft u de volgende rechten:',
    rightAccessTitle: 'Recht op Toegang',
    rightAccessText: 'Kopieën van uw persoonlijke gegevens opvragen',
    rightCorrectTitle: 'Recht op Rectificatie',
    rightCorrectText: 'Correctie van onjuiste gegevens aanvragen',
    rightDeleteTitle: 'Recht op Verwijdering',
    rightDeleteText: 'Verwijdering van uw persoonlijke gegevens aanvragen',
    rightPortabilityTitle: 'Recht op Gegevensoverdraagbaarheid',
    rightPortabilityText: 'Overdracht van uw gegevens naar een andere dienst aanvragen',
    cookiesTitle: 'Cookies en Tracking',
    cookiesText: 'We gebruiken cookies en vergelijkbare trackingtechnologieën om activiteit op ons platform te volgen en bepaalde informatie op te slaan. U kunt uw browser instrueren om alle cookies te weigeren of aan te geven wanneer een cookie wordt verzonden.',
    contactTitle: 'Neem Contact Op',
    contactText: 'Als u vragen heeft over dit Privacybeleid of uw gegevensbeschermingsrechten wilt uitoefenen, neem dan contact met ons op via:'
  }
};
